// https://ant.design/components/input/

import { Input } from 'antd'
import { PasswordProps as AntdPasswordProps } from 'antd/lib/input'
import React from 'react'

import { MessageType, useFormatMessage } from 'components/atoms/Intl/Message'

export interface InputProps extends Omit<AntdPasswordProps, 'placeholder'> {
  placeholder?: MessageType
}

const Password = ({ placeholder = '••••••••••', ...rest }: InputProps) => {
  const formatMessage = useFormatMessage()

  return (
    <Input.Password
      autoComplete="off"
      data-lpignore="true"
      placeholder={formatMessage(placeholder) as string | undefined}
      {...rest}
    />
  )
}

export default React.memo(Password)
